// @ts-nocheck
import React, { useRef } from 'react';

/**
 * OTPInput — fixed-length one-time code input. Auto-advances on keystroke,
 * supports paste, and emits the full string on every change.
 */
const OTPInput = ({ length = 6, value = '', onChange, autoFocus, className = '' }) => {
  const refs = useRef([]);
  const chars = Array.from({ length }, (_, i) => value[i] || '');

  const setChar = (idx, char) => {
    const next = chars.slice();
    next[idx] = char;
    onChange && onChange(next.join(''));
  };

  const onKeyDown = (i, e) => {
    if (e.key === 'Backspace' && !chars[i] && i > 0) {
      refs.current[i - 1] && refs.current[i - 1].focus();
    }
    if (e.key === 'ArrowLeft' && i > 0) refs.current[i - 1].focus();
    if (e.key === 'ArrowRight' && i < length - 1) refs.current[i + 1].focus();
  };

  const onInput = (i, e) => {
    const v = (e.target.value || '').replace(/\D/g, '').slice(-1);
    setChar(i, v);
    if (v && i < length - 1) refs.current[i + 1] && refs.current[i + 1].focus();
  };

  const onPaste = (e) => {
    const data = (e.clipboardData.getData('text') || '').replace(/\D/g, '').slice(0, length);
    if (!data) return;
    e.preventDefault();
    onChange && onChange(data.padEnd(value.length, ''));
    const idx = Math.min(data.length, length - 1);
    refs.current[idx] && refs.current[idx].focus();
  };

  return (
    <div className={['flex gap-2', className].join(' ')}>
      {chars.map((c, i) => (
        <input
          // eslint-disable-next-line react/no-array-index-key
          key={i}
          ref={(el) => { refs.current[i] = el; }}
          autoFocus={autoFocus && i === 0}
          value={c}
          inputMode="numeric"
          maxLength={1}
          onChange={(e) => onInput(i, e)}
          onKeyDown={(e) => onKeyDown(i, e)}
          onPaste={onPaste}
          className="mov-mono text-center outline-none transition-[border-color,box-shadow,background]"
          style={{
            width: 40, height: 46,
            border: '1px solid var(--mov-line-strong)',
            background: 'var(--mov-paper-2)',
            borderRadius: 9,
            fontSize: 18,
            color: 'var(--mov-ink)',
          }}
          onFocus={(e) => {
            e.target.style.borderColor = 'var(--mov-accent)';
            e.target.style.boxShadow = '0 0 0 3px var(--mov-accent-soft)';
            e.target.style.background = 'var(--mov-paper)';
            e.target.select();
          }}
          onBlur={(e) => {
            e.target.style.borderColor = 'var(--mov-line-strong)';
            e.target.style.boxShadow = 'none';
            e.target.style.background = 'var(--mov-paper-2)';
          }}
        />
      ))}
    </div>
  );
};

export default OTPInput;
